export default __webpack_public_path__ + "static/media/eni-ceo.dda8a092.jpg";